import { BellOutlined } from "@ant-design/icons";
import { useWebSocketReload } from "src/hook/useWebSocketReload";
import { ThemeUtil } from "src/util/ThemeUtil";
import CounterCircle from "./CounterCircle";
import useHealthCount from './hook/useHealthCount';

const BellIcon = () => {
  const data = useWebSocketReload('health-status');
  const state = useHealthCount([data]);

  if (state.bell <= 0)
    return <div className="xm-bell-icon-wrapper"><BellOutlined /></div>

  return (
    <CounterCircle counter={state.bell} xShift={55} yShift={5} color={ThemeUtil.getHsColors().error}>
      <BellOutlined />
    </CounterCircle>
  );
};

export default BellIcon;